import React, { useState, useRef, useEffect } from "react";
import {
  VerifyMobileOTPServices,
  SendMobileOTPServices,
} from "../../services/index";
import { toast } from "react-toastify";
import { timerCount } from "../../config";

const MobileVerificationOTPVerify = ({
  setMobileverifyOtp,
  setMobileVerificationOTPSent1,
  setIsconfirm,
  setCurrentStep,
}) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);
  const [mobileNumber, setMobileNumber] = useState("");
  const [timer, setTimer] = useState(timerCount);
  const [canResend, setCanResend] = useState(false);
  const [resendCount, setResendCount] = useState(2);
  const [disableResend, setDisableResend] = useState(false);
  const mobile = localStorage.getItem("newmobilenumber");
  const newNumber = `******${mobile.slice(6)}`;
  const handleSubmit = async (e) => {
    e.preventDefault();
    const otpValue = otp.join("");
    if (otpValue.length === 6) {
      const response = await VerifyAdharOtp(otpValue);
      console.log("response", response);
      if (response.status === true) {
        localStorage.setItem("userData", JSON.stringify(response?.data));
        setCurrentStep("PerferredAbhaOptions");
      }
      else{
        toast.error(response?.result?.error?.message || response?.message);
      }
    } else {
      toast.error("Please enter a valid 6-digit OTP.");
    }
  };

  const handleInputChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const SendMobileOtp = async (mobilenumber) => {
    try {
      localStorage.setItem("newmobilenumber", mobilenumber);
      const body = {
        mobileNumber: mobilenumber,
        txnId: localStorage.getItem("txnId"),
      };
      const response = await SendMobileOTPServices({ body });
      if (response.status) {
        // setAdharOtp(true);
      }
    } catch (error) {
      console.error("Error while getting token:", error);
    }
  };

  const VerifyAdharOtp = async (otp) => {
    try {
      const body = {
        otpValue: otp,
        txnId: localStorage.getItem("txnId"),
      };
      const response = await VerifyMobileOTPServices({ body });
      console.log("fdfdsfdss");
      return response;
    } catch (error) {
      console.error("Error verifying OTP:", error);
    }
  };
  // eslint-disable-next-line no-undef
  useEffect(() => {
    const mobile = localStorage.getItem("newmobilenumber");
    setMobileNumber(mobile);

    let interval = null;
    if (timer > 0) {
      setCanResend(false);
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setCanResend(true);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [timer]);
  console.log("resendCount-----------", resendCount);

  const handleResendOtp = async () => {
    if (!canResend) return;
    console.log("resendddd", resendCount);
    if (resendCount <= 0 || disableResend) {
      setDisableResend(true);
      // toast.error("You have reached the maximum resend attempts.");
      return;
    }

    try {
      const body = {
        mobileNumber: mobile,
        txnId: localStorage.getItem("txnId"),
        resent_count: resendCount,
      };
      const response = await SendMobileOTPServices({ body });
      setResendCount((prev) => {
        const newCount = prev - 1;

        if (response.resent_count === 0 || newCount <= 0) {
          setDisableResend(true);
          // toast.error("You have reached the maximum resend attempts.");
        } else {
          toast.success(`OTP resent successfully`);
        }

        return newCount;
      });
      if (response.status) {
        setTimer(timerCount);
        console.log("OTP resent successfully");
      }
    } catch (err) {
      console.error("Resend OTP failed", err);
    }
  };

  // useEffect(()=>{
  //   console.log(otp,"===+");

  // },[otp])
  // return(<p>Helloss</p>)
  console.log(disableResend, resendCount, canResend, timer, "__))_");

  return (
    <>
      <section className="container">
        <div className="abha-create-steps">
          <div className="row">
            <div className="col-md-6">
              <div className="create-abha">
                <h2>Create ABHA Number in 3 Steps</h2>
                <p>
                  Create ABHA and store all your medical records in one place.
                  Take part in the{" "}
                  <span className="highlight">
                    Ayushman Bharat Digital Mission (ABDM)
                  </span>{" "}
                  and get started on your digital health journey.
                </p>

                {/* Steps */}
                <div className="vertical-steps">
                  <div className="step-item">
                    <div className="step-marker">1</div>
                    <div className="step-content">
                      <h4>Verify Aadhaar Details</h4>
                      <p>
                        Enter your Aadhaar number and verify with OTP received
                        on Aadhaar linked mobile number.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">2</div>
                    <div className="step-content">
                      <h4>Link Mobile Number</h4>
                      <p>
                        Enter your mobile number and verify with OTP to link
                        with ABHA .
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">3</div>
                    <div className="step-content">
                      <h4>Create ABHA</h4>
                      <p>Create your ABHA Number with a unique ABHA .</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Form Card */}
            <div className="col-md-6">
              <div className="form-card content">
                <h3>Verify Your Mobile OTP</h3>
                <p className="pt-3">
                  We have sent the OTP to the mobile number ending in
                  {newNumber}.
                </p>
                <form onSubmit={handleSubmit} className="pt-3">
                  <div className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                    <div className="row otp-box-custom-row">
                      {otp?.map((digit, index) => (
                        <div
                          key={index}
                          className="col-ms-2 col-lg-2 col-xl-2 col-sm-2 col-xs-2"
                        >
                          <input
                            type="text"
                            maxLength="1"
                            placeholder="0"
                            autoComplete="off"
                            value={digit}
                            ref={(el) => (inputRefs.current[index] = el)}
                            onChange={(e) => handleInputChange(e, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            className="mobile-input otp otp-box-custom"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                  <button type="submit" className="continue-btn">
                    Continue
                  </button>
                  <p className="pt-2">
                    Didn’t receive OTP?{" "}
                    {!disableResend && resendCount > 0 && !canResend ? (
                      <span className="resend-timer">Resend in {timer}s</span>
                    ) : (
                      <button
                        type="button"
                        className={`resend-otp btn-link ${
                          disableResend ? "resend-disabled-message" : ""
                        }`}
                        onClick={handleResendOtp}
                        disabled={disableResend}
                      >
                        Resend OTP
                      </button>
                    )}
                  </p>
                  {!disableResend && resendCount > 0 && (
                    <p className="small resend-message">
                      You have {resendCount} resend attempt
                      {resendCount > 1 ? "s" : ""} left.
                    </p>
                  )}

                  {disableResend && (
                    <p className="text-danger small">
                      You have no resend attempts left.
                    </p>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MobileVerificationOTPVerify;
